"use client";

import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { darkTheme, lightTheme } from "./theme";
import { darkThemeAB, lightThemeAB } from "./themeAB";
import { useBrand } from "../../contexts/BrandContext";
import { applicationVariants } from "@ea/shared_types/next/ea.consts";

type Mode = "light" | "dark";
type ThemeEA = typeof darkTheme | typeof lightTheme;
type ThemeAB = typeof darkThemeAB | typeof lightThemeAB;
export type Theme = ThemeEA | ThemeAB;

const themeMap = {
  EA: {
    light: lightTheme,
    dark: darkTheme,
  },
  AB: {
    light: lightThemeAB,
    dark: darkThemeAB,
  },
} as const;

export function ThemeRegistry({
  children,
  mode = "light",
}: {
  children: React.ReactNode;
  mode?: Mode;
}) {
  const { appVariant } = useBrand();
  const variantConfig = applicationVariants[appVariant];

  const theme: Theme = React.useMemo(() => {
    const themeVariant = variantConfig.themeVariant;
    return themeMap[themeVariant][mode];
  }, [variantConfig.themeVariant, mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
